// Browser fullscreen for the video player. In fullscreen the browser always handles Escape
// (even when focus is inside a cross-origin player), so leaving is reliable.
// Where fullscreen isn't available (e.g. iPhone Safari), callers fall back to a full-window layout.
import {onMounted, onUnmounted} from "vue";

// call directly from a user gesture, such as a click; resolves to whether fullscreen was granted
export const requestFullscreen = async (element) => {
  if (!document.fullscreenEnabled || !element?.requestFullscreen) return false;
  try {
    await element.requestFullscreen();
    return true;
  } catch {
    return false;
  }
};

export const isFullscreen = () => Boolean(document.fullscreenElement);

export const exitFullscreen = () => document.exitFullscreen().catch(() => {});

// calls onExit when the browser fully leaves fullscreen, not when a player exits its own
export const useFullscreenExit = (onExit) => {
  const onChange = () => {
    if (!isFullscreen()) onExit();
  };
  onMounted(() => document.addEventListener("fullscreenchange", onChange));
  onUnmounted(() => document.removeEventListener("fullscreenchange", onChange));
};
